import { render, staticRenderFns } from "./Breadcrumbs.vue?vue&type=template&id=5fd5c5fb&scoped=true"
import script from "./Breadcrumbs.vue?vue&type=script&lang=js"
export * from "./Breadcrumbs.vue?vue&type=script&lang=js"
import style0 from "./Breadcrumbs.vue?vue&type=style&index=0&id=5fd5c5fb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd5c5fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3254644805/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fd5c5fb')) {
      api.createRecord('5fd5c5fb', component.options)
    } else {
      api.reload('5fd5c5fb', component.options)
    }
    module.hot.accept("./Breadcrumbs.vue?vue&type=template&id=5fd5c5fb&scoped=true", function () {
      api.rerender('5fd5c5fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Layout/Breadcrumbs.vue"
export default component.exports